module.exports = __webpack_public_path__ + "img/operation_guide.f91d2671.png";